import React, { useMemo } from 'react';

import { parseReceivedNotifications } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import InfoBox from './InfoBox';
import { MessageGroup } from 'components';

const MessagesSection = props => {
    const { distributor } = props;

    const receivedMessages = useMemo(
        () => parseReceivedNotifications(distributor?.user?.receivedNotifications || []),
        [distributor]
    );

    return (
        <InfoBox title={texts.MESSAGES} disableContentWrapper>
            <MessageGroup messages={receivedMessages} />
        </InfoBox>
    );
};

export default MessagesSection;
